type SvgProps = React.SVGProps<SVGSVGElement>;

export const BookIcon = (props: SvgProps) => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5625"
      y="0.5625"
      width="43.875"
      height="43.875"
      rx="21.9375"
      fill="#EEE9FF"
    />
    <rect
      x="0.5625"
      y="0.5625"
      width="43.875"
      height="43.875"
      rx="21.9375"
      stroke="url(#paint0_linear_3425_4877)"
      stroke-width="1.125"
    />
    <path
      d="M32.6242 14.912V26.7578C32.6242 28.6308 31.3662 30.2988 29.5648 30.8143L23.89 32.4351C22.9805 32.695 22.0187 32.695 21.1091 32.4351L15.4343 30.8143C13.633 30.2997 12.375 28.6317 12.375 26.7578V15.7557C12.3801 14.6521 14.0574 14.653 14.0624 15.7557V26.7578C14.0624 27.8824 14.8176 28.8831 15.8984 29.1919L21.5732 30.8127C22.1798 30.9856 22.8202 30.9856 23.4277 30.8127L29.1016 29.1919C30.1824 28.8831 30.9376 27.8824 30.9376 26.7578V14.912C30.9426 13.8084 32.6191 13.8093 32.6242 14.912ZM15.7499 24.9834V15.7557C15.7499 14.6867 16.2392 13.7046 17.0922 13.0617C17.9452 12.418 19.0235 12.2172 20.052 12.5108L21.5082 12.9267C21.8845 13.0339 22.2212 13.2254 22.5004 13.476C22.7797 13.2254 23.1163 13.0339 23.4926 12.9267L24.948 12.5108C27.0244 11.8544 29.3109 13.5806 29.2501 15.7557V24.9834C29.2501 26.4819 28.2436 27.8166 26.8025 28.2284L23.8909 29.0603C22.9805 29.3201 22.0187 29.3201 21.11 29.0603L18.1983 28.2284C16.7573 27.8166 15.7499 26.4819 15.7499 24.9834ZM23.3433 27.4606C23.3711 27.453 26.3376 26.6059 26.3376 26.6059C27.0582 26.4 27.5619 25.7326 27.5619 24.9834V15.7557C27.5619 15.2216 27.3172 14.7306 26.8911 14.4083C26.4625 14.0843 25.92 13.9873 25.4112 14.1324L23.9558 14.5484C23.5956 14.6513 23.3433 14.9846 23.3433 15.3592V27.4606ZM17.4373 24.9834C17.4373 25.7326 17.941 26.4 18.6615 26.6059C18.6615 26.6059 21.628 27.453 21.6559 27.4606V15.36C21.6559 14.9854 21.4044 14.6521 21.0442 14.5492L19.5879 14.1333C19.0792 13.9873 18.5358 14.0852 18.108 14.4091C17.682 14.7306 17.4373 15.2216 17.4373 15.7566V24.9834Z"
      fill="#784EFF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3425_4877"
        x1="22.5"
        y1="0"
        x2="22.5"
        y2="45"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBA7FF" />
        <stop offset="1" stop-color="#BBA7FF" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
